import { Box, Fade, IconButton } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Reply as ReplyContent } from '$common/reply'
import { CloseIcon } from '$common/icons/close'

const StyledBox = styled(Box)`
  display: flex;
  /* @noflip */
  padding: 5px 4px 4px 12px;
  background-color: white;
  border-radius: 8px 8px 0 0;
  z-index: 1;
  align-items: center;
  gap: 4px;
`

interface Props {
  roomId: string
  messageIid: number
  onCancel: () => any
}
export function Reply({ messageIid, roomId, onCancel }: Props) {
  return (
    <Fade in>
      <StyledBox>
        <IconButton onClick={onCancel}>
          <CloseIcon sx={{ color: 'gray' }} />
        </IconButton>
        <ReplyContent
          roomId={roomId}
          messageIid={messageIid}
          fromMe={false}
          showReplyIcon
        />
      </StyledBox>
    </Fade>
  )
}
